/* eslint-disable */

import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { BarLoader } from "../../../../shared/widgets";
import { templateStrings } from "../../../../Constant";
import { TableWrapper, PageWrapper } from "../../../../shared/layout";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { passRevenueDistributionAction } from "../../../../redux/action-creators/distanceReportActionCreator";
import { getListUtil } from "../../../../shared/utils";

class PassRevenueProductsDistribution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.passRevenueProductGetList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps && prevProps.cityFilter != this.props.cityFilter)
      || (prevProps && prevProps.operatorFilter != this.props.operatorFilter)
      || (prevProps && prevProps.dateFilter != this.props.dateFilter)
    ) {
      this.passRevenueProductGetList();
    }
  }

  onSortToggle = (value, key) => {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.passRevenueProductGetList();
      },
    );
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.passRevenueProductGetList();
      }
    });
  };

  passRevenueProductGetList = () => {
    if (
      get(this, "props.location.state.fromDate", null)
      && get(this, "props.location.state.toDate", null)
    ) {
      getListUtil({
        dispatchFn: this.props.fetchPassRevenueDistribution, props: this.props, state: this.state, extraParam: "header",
      });
    } else {
      const { history } = this.props;
      history.push("/report/mobile-ticket");
    }
  };

  render() {
    const { headerLoader, content, totalItems } = this.props;
    const {
      pageNo, rowsPerPage, sortBy, selected,
    } = this.state;
    const templateString = templateStrings.passRevenueDistribution;
    return (
      <div className="pageContainer">
        <PageWrapper>
          <PageWrapper.Header
            heading="Pass Products"
            showBackArrow
            hideS
          />
          <BarLoader scope="header" />
          <TableWrapper
            content={!headerLoader && content}
            pageNo={pageNo}
            selected={selected}
            uniqueKey="uniqKey"
            rowsPerPage={rowsPerPage}
            count={totalItems}
            handleChange={this.handleChange}
            templateString={templateString}
            selectionAllowed={false}
            onSortToggle={this.onSortToggle}
            sortBy={sortBy}
            handleAction={() => { }}
          />
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state && state.Report && state.Report.passDetails && state.Report.passDetails.data) || [],
    totalItems:
      (state && state.Report && state.Report.passDetails && state.Report.passDetails.totalItems) || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  fetchPassRevenueDistribution: (value, loaderScope) => {
    dispatch(passRevenueDistributionAction(value, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PassRevenueProductsDistribution);
